import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options) => {
  const response = await api.get("kam/files", options);

  return response;
};

export const get = async (id) => {
  const response = await api.get(`kam/files/${id}`, {
    responseType: "blob",
  });

  return response;
};

export const post = async (
  file,
  options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: {
      showMessage: true,
    },
  },
) => {
  const response = await api.post("kam/files", file, options);

  return response;
};

export const postOnboarding = async (
  file,
  options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: {
      showMessage: true,
      PII: 1,
    },
  },
) => {
  const response = await api.post(
    `/kam/user/${file.user_id}/files`,
    file,
    options,
  );

  return response;
};

export const put = async (file) => {
  const response = await api.put("kam/files", file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

export const remove = async (_id, payload) => {
  const response = await api.put(`kam/file/${_id}`, payload);

  return response;
};

export const removeOnboarding = async (_id, payload) => {
  const response = await api.put(`/kam/user/files/${_id}/remove`, payload);

  return response;
};

export const restore = async (_id, payload) => {
  const response = await api.put(`kam/file/restore/${_id}`, payload);

  return response;
};
